import { render, staticRenderFns } from "./SettingsVideos.vue?vue&type=template&id=1e5120fa"
import script from "./SettingsVideos.vue?vue&type=script&lang=js"
export * from "./SettingsVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports